/**
 * SFX WebAudio 100% sintetici (pattern AudioEngine Zoolympics, versione minima Sprint 0).
 * Init lazy al primo gesto utente; ogni chiamata è best-effort.
 */

let ctx: AudioContext | null = null;

function ac(): AudioContext | null {
  try {
    if (!ctx) ctx = new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function blip(freq: number, at: number, dur: number, gainPeak: number, type: OscillatorType = 'triangle'): void {
  const a = ac();
  if (!a) return;
  const osc = a.createOscillator();
  const gain = a.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, a.currentTime + at);
  gain.gain.linearRampToValueAtTime(gainPeak, a.currentTime + at + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + at + dur);
  osc.connect(gain).connect(a.destination);
  osc.start(a.currentTime + at);
  osc.stop(a.currentTime + at + dur + 0.05);
}

function noise(at: number, dur: number, gainPeak: number, filterFreq: number): void {
  const a = ac();
  if (!a) return;
  const len = Math.ceil(a.sampleRate * dur);
  const buf = a.createBuffer(1, len, a.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const src = a.createBufferSource();
  src.buffer = buf;
  const filter = a.createBiquadFilter();
  filter.type = 'bandpass';
  filter.frequency.value = filterFreq;
  const gain = a.createGain();
  gain.gain.value = gainPeak;
  src.connect(filter).connect(gain).connect(a.destination);
  src.start(a.currentTime + at);
}

/** Click secco quando tieni/rilasci un dado. */
export function sfxHold(held: boolean): void {
  blip(held ? 660 : 440, 0, 0.06, 0.12, 'square');
}

/** Rattle del bicchiere: raffica di impulsi rumorosi. */
export function sfxRattle(durMs: number): void {
  const bursts = Math.floor(durMs / 70);
  for (let i = 0; i < bursts; i++) noise(i * 0.07, 0.045, 0.10, 1800 + Math.random() * 1500);
}

/** Thunk di un dado che si ferma sul feltro. */
export function sfxSettle(): void {
  noise(0, 0.05, 0.16, 900);
  blip(120, 0, 0.09, 0.18, 'sine');
}

/** Tick del contatore che macina punti. */
export function sfxScoreTick(progress: number): void {
  blip(500 + progress * 700, 0, 0.035, 0.06, 'square');
}

/** Fanfara proporzionale alla grossezza della combo. */
export function sfxFanfare(level: 1 | 2 | 3): void {
  const roots = level === 3 ? [523, 659, 784, 1047] : level === 2 ? [440, 554, 659] : [392, 494];
  roots.forEach((f, i) => blip(f, i * 0.09, 0.35, 0.14, 'triangle'));
  if (level >= 3) noise(0.05, 0.4, 0.12, 2500);
}
